<div *ngIf="_characters">
  <div>
    <div class="form-group">
      <label for="theme">Select character</label>
      <nb-select filled status="primary" placeholder="Select character"
        [(ngModel)]="selectedCharacter" [ngModelOptions]="{standalone: true}" (selectedChange)="onCharacterChange()">
        <nb-option *ngFor="let character of _characters" [value]="character">{{character.labels | txtTranslate}}</nb-option>
      </nb-select>
    </div>
  </div>
  <div>
    <div class="form-group" *ngIf="selectedCharacter">
      <label for="theme">Select mood</label>
      <nb-select filled status="primary" placeholder="Select mood"
        [(ngModel)]="selectedMood" [ngModelOptions]="{standalone: true}" (selectedChange)="onMoodChange()">
        <nb-option *ngFor="let mood of selectedCharacter.moods" [value]="mood">
          <img [src]="mood.fileURL" alt="img" class="w-8 h-8 my-0"> {{mood.name}}
        </nb-option>
      </nb-select>
    </div>
  </div>
</div>

<div class="">
  <multilang-editor [model]="_model.data.text" editMode="true" [htmlMode]="htmlMode" 
      [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>
</div>
<div>
  <app-dialog-viewer [model]="_model" [languages]="languages" [defaultLang]="defaultLang" [characters]="_characters"></app-dialog-viewer>
</div>

<div>
  <app-editor-media [languages]="languages" [model]="_model.data.image" [gameId]="gameId" [templateId]="templateId"></app-editor-media>
</div>

<!--_model.data.image:{{_model.data.image | json}}-->

<!--<div>
  json:{{_model | json}}  
</div>-->

  <!--<img [src]="selectedMood?.fileURL"/>-->

  <!--<app-dialog [image]="selectedMood?.fileURL">
    <div [innerHtml]="'Hello there!'"></div>
  </app-dialog>-->
  